export const getDistinctObjectsByPath = <T extends any[]>(array: T, path1: string, path2: string): T => {
  return [...new Map(array.map((item) => [item[path1][path2]?.toLowerCase(), item]))
    .values()] as T;
};

export const getDistinctObjectsByProperty = <T extends any[]>(array: T, property: string): T => {
  return [...new Map(array.map((item) => [item[property]?.toLowerCase(), item]))
    .values()] as T;
};
